import { hydrationDebugData } from './const';
import { isDebugHydrationEnabled } from './util';

// Snapshot the SSR HTML on module load to compare against the CSR HTML on hydration error
if (isDebugHydrationEnabled()) {
  window[hydrationDebugData] = {
    error: false,
    ssrHtml: '',
    csrHtml: '',
  };
  const root = document.querySelector('#ssr-main');
  if (root) {
    window[hydrationDebugData].ssrHtml = root.innerHTML;
  }
}

/**
 * Handler to catch hydration errors and snapshot the CSR HTML for comparison
 * with the SSR HTML. Used as the `onRecoverableError` callback for `hydrateRoot`.
 *
 * @example
 * ```tsx
 * import { hydrateRoot } from 'react-dom/client';
 * import { debugHydrateRootHandler } from '@ui/HydrationDebugger';
 *
 * hydrateRoot(document.getElementById('root'), <App />, {
 *   onRecoverableError: debugHydrateRootHandler,
 * });
 * ```
 */
export function debugHydrateRootHandler(error) {
  if (!isDebugHydrationEnabled()) return;

  const msg = error?.message?.toLowerCase() || '';

  // Roughly matching these two common hydration error messages:
  // 1. "Error: Hydration failed because the initial UI does not match what was rendered on the server."
  // 2. "Error: There was an error while hydrating. Because the error happened outside of a Suspense boundary,
  //     the entire root will switch to client rendering."
  const isHydrationMsg = msg.includes('hydration') || msg.includes('hydrating');

  if (window[hydrationDebugData] && isHydrationMsg) {
    window[hydrationDebugData].error = true;
    const root = document.querySelector('#ssr-main');
    if (root) {
      window[hydrationDebugData].csrHtml = root.innerHTML;
    }
  }
}
